import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LINKS } from '../data/site';
export function StorySection() {
  return <section className="border-t border-steel-200 bg-white" aria-labelledby="story-heading" data-id="element-244" data-mp="gzwg9jmfdwqj">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-20" data-id="element-245" data-mp="c2edkaz04dqz">
        <div data-id="element-246" data-mp="81kr7m17j707">
          <p className="font-display text-[13px] uppercase tracking-eyebrow text-fred" data-id="element-247" data-mp="7xww4ig46cjd">Since 1991</p>
          <h2 id="story-heading" className="mt-4 font-display text-[36px] font-bold uppercase leading-[0.95] text-charcoal sm:text-[46px]" data-id="element-248" data-mp="14o64es742wku">
            A metal shaping tradition,
            <br data-id="element-249" data-mp="qqhlhpwltzif" />
            carried forward.
          </h2>
          <p className="mt-5 max-w-[52ch] text-[16px] leading-relaxed text-steel-600 sm:text-[17px]" data-id="element-250" data-mp="qpzfi1k546xb">
            Founded by Ron Fournier in 1991, Fournier Enterprises continues under owner, fabricator and
            instructor Jeff Fournier. The work done in the shop informs the tools we offer and the skills we
            teach.
          </p>
          <a href={LINKS.story} className="mt-7 inline-flex min-h-[48px] items-center gap-2 border border-charcoal px-6 font-display text-[19px] uppercase tracking-[0.06em] text-charcoal transition-colors duration-150 ease-out hover:bg-charcoal hover:text-white" data-id="element-251" data-mp="1t6iy82exycsy">
            Our Story
          </a>
        </div>

        <figure className="flex flex-col justify-center border-l-2 border-fred bg-cream p-7 sm:p-9" data-id="element-252" data-mp="15fnaphhiq3ri">
          <blockquote className="font-display text-[26px] uppercase leading-[1.15] text-charcoal sm:text-[30px]" data-id="element-253" data-mp="1a9hok4afzoio">
            <p data-id="element-254" data-mp="wefcezf052xf">
              “Jeff was great, very patient with me, especially toward the end of the day when I was running
              out of steam.”
            </p>
          </blockquote>
          <figcaption className="mt-6 text-[14px] text-steel-600" data-id="element-255" data-mp="mj46n6lkn61t">
            <span className="font-medium text-charcoal" data-id="element-256" data-mp="rgdskc9r4zkw">Marshall Banks · Magnolia, Texas</span>
            <span className="mt-1 block text-[12px] uppercase tracking-[0.12em] text-steel-600" data-id="element-257" data-mp="2t6uw7fwkjxil">
              Workshop student
            </span>
          </figcaption>
          <a href={LINKS.testimonials} className="mt-6 inline-flex min-h-[44px] items-center gap-2 text-[15px] text-charcoal underline decoration-steel-200 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-fred" data-id="element-258" data-mp="2keasi11f72qw">
            More customer stories
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-259" data-mp="384546fa06l9k" />
          </a>
        </figure>
      </div>
    </section>;
}